export interface MatchingPreset {
    label: string;
    productKey: string;
    productVersion: number;
    culture: string;
    documentSourceUri: string;
    productOptions?: Record<string, string>;
    siteResultUri?: string;
    dpcId?: string;
    sourceProductKey?: string;
    sourceProductVersion?: number;
    sourceProductOptions?: Record<string, string>;
}

export const MATCHING_PRESETS: MatchingPreset[] = [
    {
        label: 'Template Match Example',
        productKey: 'PRD-QLNQJBYP',
        productVersion: 25,
        culture: 'en-us',
        documentSourceUri: 'https://storage.documents.cimpress.io/v3/documents/571c499b-f2ef-4348-8020-8f9e3a6074f2~200/revisions/ad37b1a8-256b-4225-8eb1-4e5a2dc01289~200',
    },
    {
        label: 'Resizer Match Example',
        productKey: 'PRD-ENRS4XZIS',
        productVersion: 49,
        culture: 'en-us',
        documentSourceUri: 'https://storage.documents.cimpress.io/v3/documents/01ed4c3e-c074-48c6-aa03-e7dfc5ea1f02~200/revisions/51d63879-78e6-49ec-ab99-c013aeb7dd5d~200',
        productOptions: {
            Size: '4.2" x 5.5"',
        },
    },
    {
        label: 'Photo Match Example',
        productKey: 'PRD-ADZNM4LP',
        productVersion: 50,
        culture: 'en-us',
        documentSourceUri: 'https://storage.documents.cimpress.io/v3/documents/24a9260c-cb07-41ae-aab6-9acfd7980602~200/revisions/9385446a-1d20-4abd-927b-5bbbae51ed8c~200',
    },
    {
        label: 'Logo Match Example',
        productKey: 'PRD-OVINFUUGV',
        productVersion: 19,
        culture: 'en-us',
        documentSourceUri: 'https://storage.documents.cimpress.io/v3/documents/f424d4ae-b564-4da9-82b5-5883765ade91~200/revisions/78568daf-74cf-4521-8af2-d6cca5c49e2e~200',
        productOptions: {
            'Substrate Color': '#5c6569',
        },
    },
    {
        label: 'NEW Logo Match Example',
        productKey: 'PRD-OVINFUUGV',
        productVersion: 19,
        culture: 'en-us',
        documentSourceUri: 'https://uds.documents.cimpress.io/v3/documents/63bc9ccd-1efe-4629-bb19-076f9297a258~100/revisions/363ab786-1649-41c2-acb0-385d75a40a1c~100',
    },
];
